import userFlowMixin from '@/modules/User/mixins/userFlowMixin'

export default {
  mame: 'damageItem',
  mixins: [userFlowMixin],
  props: {
    damage: {
      type: Object,
      required: true
    }
  },
  computed: {
    flowName() {
      return this.getUserFlow
    }
  }
}
